export default class RandomNumberGenerator {
    getRandomInclusive(max){
        return Math.floor(Math.random() * (max + 1));
    }

    getRandomExclusive(max){
        return Math.floor(Math.random() * (max));
    }
}



// WEBPACK FOOTER //
// ./src/utils/randomNumberGenerator.js